import { autoinject, transient, BindingEngine } from "aurelia-framework";
import { Router } from "aurelia-router";
import { RightShipQiRouterConstants } from "../../../../configuration/rightshipqi-router.constants";
import { Claims } from "../../../../constants/authentication/claims";
import { StepModel } from "../../../../models/basics/basics.models";
import { UserClaimsService } from "../../../../services/authentication/user-claims.service";
import { ViewPeople } from "../../settings/view-people";
import { CustomersList } from "./customers-list";


@autoinject()
@transient()
export class Customers {
   
    public currentTab: StepModel;
    public canAddCustomers: boolean = false;
    public modelInCompose: any = {};

    constructor(protected bindingEngine: BindingEngine, private router: Router, private customersList: CustomersList,
        private viewPeople: ViewPeople, userClaimsService: UserClaimsService) {
            this.tabs=  [
                {
                    show: () => true,
                    title: "Customer List",
                    step: 1,
                    vm: this.customersList,
                },
                {
                    show: () => true,
                    title: "People",
                    step: 2,
                    vm: this.viewPeople,
                    lazyLoad: true,           
                    onClick: () => {
                        this.modelInCompose = {
                            showAllCustomers: true,
                            filterByIsActive: true
                        };
                    }
                }
            ];
        this.currentTab = this.tabs[0];
        this.canAddCustomers = userClaimsService.hasPermission(Claims.CanAddCustomers);
    }

    tabs: StepModel[];
   
    addNewCustomer() {
        this.router.navigateToRoute(RightShipQiRouterConstants.RouteNames.CreateCustomer, {
            id: 0
        });
    }
}